var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4441 2.99993C14.5562 2.99951 14.6669 3.02694 14.7681 3.08022C14.8694 3.13349 14.9586 3.21125 15.0292 3.30779L18.6516 8.29997C18.762 8.44885 18.8223 8.63559 18.8223 8.82831C18.8223 9.02103 18.762 9.20778 18.6516 9.35665L14.9016 14.3488C14.7743 14.5188 14.5914 14.6256 14.3931 14.6459C14.1948 14.6662 13.9973 14.5982 13.8442 14.457C13.691 14.3158 13.5947 14.1128 13.5764 13.8928C13.5581 13.6728 13.6193 13.4538 13.7467 13.2838L17.0991 8.82415L13.8592 4.36446C13.7674 4.24233 13.7092 4.09362 13.6913 3.93591C13.6734 3.7782 13.6965 3.61809 13.7581 3.47454C13.8196 3.331 13.917 3.21001 14.0385 3.1259C14.1601 3.04179 14.3009 2.99808 14.4441 2.99993Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.6544bbb527cb644630cb9baaa6ea5086.svg";
export { ForwardRef as ReactComponent };